<template>
  <div>
    <v-row>
      <v-col cols="12" class="mt-4" v-if="space == 1"></v-col>
      <v-col v-else cols="12" v-for="i in space" :key="i"></v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    space: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
